import React from "react";
import "./Social.scss";
import telegram from "../../assets/icons/telegram-card.png";
import instagram from "../../assets/icons/instagram-card.png";

const Social = ({ exchangeData }) => {
  return (
    <div className="social-container wide-page-margin">
      <div>
        <img src={telegram} alt="telegram" />
        <div className="social-card flex flex-col items-end justify-center relative bottom-[17rem] left-[5rem]">
          <div className="social-item">Telegram <br></br> @iexchangee</div>
          <a  target="_blank" className="gradient-btn-1" href="https://t.me/iexchangee">
            کلیک کنید
          </a>
        </div>
      </div>
      <div className="max-[540px]:relative max-[540px]:top-[-9rem]" >
        <img src={instagram} alt="instagram" />
        <div className="social-card flex flex-col items-end justify-center relative bottom-[17rem] left-[5rem]">
          <div className="social-item">Instagram <br></br> @sarafiiex</div>
          <a target="_blank" className="gradient-btn-1" href="https://www.instagram.com/p/DaHxzN1DV1M">
            کلیک کنید
          </a>
        </div>
      </div>
    </div>
  );
};

export default Social;
